import type { ContainerTabsListProps } from './types'
import styles from './ContainerTabs.module.css'

/**
 * Container para os botões de aba.
 * Renderiza as abas integradas no topo do container.
 */
export function ContainerTabsList({
  children,
  className,
  'aria-label': ariaLabel,
}: ContainerTabsListProps) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel || 'Abas de navegação'}
      className={[styles.containerTabsList, className].filter(Boolean).join(' ')}
    >
      {children}
    </div>
  )
}
